/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Permissions_Role_CountInputs */

const en_tables_permissions_role_count = /** @type {(inputs: Tables_Permissions_Role_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Count`)
};

const de_tables_permissions_role_count = /** @type {(inputs: Tables_Permissions_Role_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Rollen`)
};

/**
* | output |
* | --- |
* | "Role Count" |
*
* @param {Tables_Permissions_Role_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_permissions_role_count = /** @type {((inputs?: Tables_Permissions_Role_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Permissions_Role_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_permissions_role_count(inputs)
	return de_tables_permissions_role_count(inputs)
});